import { render, staticRenderFns } from "./ProductServiceDetail.vue?vue&type=template&id=7caef1e0&scoped=true&"
import script from "./ProductServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ProductServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductServiceDetail.vue?vue&type=style&index=0&id=7caef1e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caef1e0",
  null
  
)

export default component.exports